<script setup lang="ts">
import type { IInfoConsultationProps } from '@/widgets/LawyerCard/model/types/lawyerCard';

withDefaults(defineProps<IInfoConsultationProps>(), {
  isAppointmentRegion: false,
  isAppointmentOnline: false,
  isArticle: false,
});

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['info-consultation', { _mobile: isMobile }, { _article: isArticle }]">
    <span v-if="isAppointmentRegion" class="info-consultation__text">
      <AppIcon class="info-consultation__icon" name="Office" />
      Доступен для записи в офис
    </span>
    <span v-if="isAppointmentOnline" class="info-consultation__text">
      <AppIcon class="info-consultation__icon" name="Laptop" />
      Доступен для онлайн консультации
    </span>
  </div>
</template>

<style lang="less">
.info-consultation {
  margin: 10px 0 0;
  color: @color-mountain-meadow;
  display: flex;
  will-change: transform;
  flex-direction: column;

  &__text {
    display: flex;
    align-items: center;
    gap: @main-size;
    font-size: 13px;
    line-height: 17px;
    font-weight: 500;

    &:not(:last-child) {
      margin-bottom: @main-size;
    }
  }

  &__icon {
    width: @size-x3;
    height: @size-x3;

    path {
      fill: @color-mountain-meadow;
    }
  }

  &._article &__text {
    font-size: 11px;
    line-height: 15px;
  }

  &._mobile {
    margin-top: @size-x2;
    align-items: flex-start;

    span {
      font-size: @size-x3;
      line-height: @size-x4;

      &.app-icon {
        margin-left: 0;
      }
    }

    &:not(:last-child) {
      margin-bottom: @main-size;
    }
  }
}
</style>
